<template>
    <RightIcon style="transform: rotate(180deg)" />
</template>

<script setup>
import RightIcon from '@/components/icons/RightIcon.vue'
</script>
